export default "__VITE_ASSET__cMXdoxPf__"